import { useRef, useState } from 'react'

import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'

import TextFieldUser from '../custom_Componet/TextFieldUser'
import PasswordUser from '../custom_Componet/PasswordUser'
import TokenField from '../custom_Componet/TokenField'
import { iuseHooks } from '../hooks/iuseHooks'

import logo from '../img/SPH - APP-11.png'
const CoreLogin = () => {
  const childPw = useRef(null)
  const childIu = useRef(null)
  const childTK = useRef(null)
  const [stateShowPassword, setstateShowPassword] = useState('password')
  const [stateObjLoggin, setstateObjLoggin] = useState(() => {
    return {
      tiu: '',
      iu: '',
      tk: '',
      eiu: ''
    }
  })
  const [stateObjPassword, setstateObjPassword] = useState(() => {
    return {
      pw: '',
      epw: false
    }
  })
  const [stateObjToken, setstateObjToken] = useState(() => {
    return {
      tk: '',
      etk: false
    }
  })
  const [stateDiss, setstateDiss] = useState({
    diu: false,
    dpw: false,
    dtk: false,
    loggin: false
  })
  const [stateHelper, setstateHelper] = useState({
    tiu: '', //Titulo Usuario
    tpw: '', //Titulo Password
    ttk: '', //Titulo del Token
    epw: false, //Estatus Password
    eiu: false, //Estatus Usuario
    etk: false, //Estatus Token
    dip: false //Display Token
  })
  const [dataRESP, setdataRESP] = useState({})
  const { onProcess, onToken } = iuseHooks()

  const haldlenFieldsForm = (value) => {
    if (value) {
      childPw.current.value = ''
      childIu.current.value = ''
      if (childTK && childTK.current) childTK.current.value = ''
      childIu.current.focus()
    } else {
      childTK.current.value = ''
      childTK.current.focus()
    }
  }

  const onClickCall = () => {
    const { dip } = stateHelper
    if (!dip)
      onProcess(stateObjLoggin, stateObjPassword, stateHelper, setstateDiss, setstateHelper, setdataRESP).then(
        haldlenFieldsForm
      )
    else {
      const idauth = dataRESP[3]
      const token = stateObjToken.tk
      onToken({ idauth, token }, dataRESP, stateHelper, stateDiss, setstateHelper, setstateDiss).then(haldlenFieldsForm)
    }
  }

  const onChangeForm = (e) => {
    const {
      currentTarget: { value },
      target: { name }
    } = e
    switch (name) {
      case 'Usuario':
        setstateObjLoggin({ ...stateObjLoggin, iu: value })
        setstateHelper({
          ...stateHelper,
          tiu: '',
          tpw: '',
          ttk: '',
          epw: false,
          eiu: false,
          etk: false
        })
        break
      case 'Password':
        setstateObjPassword({ ...stateObjPassword, pw: value })
        break
      case 'Token':
        setstateObjToken({ ...stateObjToken, tk: value })
        break
      default:
        break
    }
  }
  //** Function Process Input User */
  const onKeypressUser = (e) => {
    const { iu } = stateObjLoggin
    if (e.key === 'Enter' && iu !== '') childPw.current.focus()
  }

  //** Function Process Input Password */
  const onKeypressPassword = (e) => {
    const { pw } = stateObjPassword

    if (e.key === 'Enter' && pw !== '') {
      onClickCall()
    }
  }

  //** Function Process Input Token */
  const onKeypressToken = (e) => {
    const { tk } = stateObjToken

    if (e.key === 'Enter' && tk !== '') {
      onClickCall()
    }
  }

  //** Display Password Eyes  */
  const handleClickShowPassword = () => {
    if (stateShowPassword === 'password') setstateShowPassword('text')
    else setstateShowPassword('password')
  }

  return (
    <Grid>
      <Grid xs={11} item>
        <Grid container direction="column" justify="center" alignItems="center">
          <img src={logo} alt="logo" style={{ position: 'relative', width: '60%', paddingLeft: '20px' }} />
        </Grid>
      </Grid>
      <Grid xs={11} item className="item-User">
        <Grid
          style={{
            backgroundColor: '#fff',
            borderRadius: '6px',
            boxShadow: ' 10px 10px 63px 0px #000010'
          }}
        >
          <TextFieldUser
            childIu={childIu}
            stateHelper={stateHelper}
            stateDiss={stateDiss}
            onChangeUser={onChangeForm}
            onKeypressUser={onKeypressUser}
          />
        </Grid>
      </Grid>
      <Grid xs={11} item className="item-Password">
        <Grid
          style={{
            backgroundColor: '#fff',
            borderRadius: '6px',
            boxShadow: ' 10px 10px 63px 0px #000010'
          }}
        >
          <PasswordUser
            childPw={childPw}
            stateHelper={stateHelper}
            stateDiss={stateDiss}
            stateShowPassword={stateShowPassword}
            onChangePassword={onChangeForm}
            onKeypressPassword={onKeypressPassword}
            handleClickShowPassword={handleClickShowPassword}
          />
        </Grid>
      </Grid>
      {stateHelper.dip ? (
        <Grid xs={11} item className="item-token">
          <Grid
            style={{
              backgroundColor: '#fff',
              borderRadius: '6px',
              boxShadow: ' 10px 10px 63px 0px #000010'
            }}
          >
            <TokenField
              childTK={childTK}
              stateHelper={stateHelper}
              stateDiss={stateDiss}
              onChangeUser={onChangeForm}
              onKeypressToken={onKeypressToken}
            />
          </Grid>
        </Grid>
      ) : (
        <div></div>
      )}
      <Grid container justify="center" alignContent="center" alignItems="center">
        <Grid item xs={10} className="item-Button">
          {stateDiss.loggin ? (
            <CircularProgress size={20} />
          ) : (
            <Button onClick={onClickCall} variant="contained" color="primary" style={{ width: '100%' }}>
              Entrar
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}
export default CoreLogin
